import { LeadModel, MergedFileModel } from '@/typings/models/Lead';

/**
 * Merge user uploads (`files`) and customer/widget uploads (`customer_files`)
 * into a single, source-tagged list, sorted newest first. Both file types are
 * keyed by `uuid` — usable for deletion via their respective endpoints.
 */
export function getMergedLeadFiles(
  lead?: Pick<LeadModel, 'files' | 'customer_files'> | null,
): MergedFileModel[] {
  if (!lead) return [];

  const userFiles: MergedFileModel[] = (lead.files || []).map((file) => ({
    id: file.uuid,
    source: 'user',
    path: file.path,
    uploaded_at: file.uploaded_at,
    size: file.size,
    uploaded_by: file.uploaded_by ?? null,
  }));

  const customerFiles: MergedFileModel[] = (lead.customer_files || []).map(
    (file) => ({
      id: file.uuid,
      source: 'customer',
      path: file.path,
      uploaded_at: file.uploaded_at,
      uploaded_by: null,
    }),
  );

  return [...userFiles, ...customerFiles].sort((a, b) =>
    (b.uploaded_at || '').localeCompare(a.uploaded_at || ''),
  );
}
